<template>
  <p>We can’t show this page because we don’t know which surgery it’s for.</p>
  <ul>
    <li>If you typed the web address, check it’s correct.</li>
    <li>If you copied and pasted it, make sure you copied the entire address.</li>
    <li>If you still can’t continue, contact your surgery for help.</li>
  </ul>
</template>
<script setup lang="ts"></script>
